module.exports = __webpack_public_path__ + "img/icon_comment.a6054afc.svg";